/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';
import React from 'react';

var DefaultSeperator = function DefaultSeperator() {
  var _useTheme = useTheme(),
      direction = _useTheme.direction;

  var rootStyles = /*#__PURE__*/css({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    color: '#77818f',
    content: '""',
    right: direction === 'ltr' ? '5px' : undefined,
    left: direction === 'rtl' ? '5px' : undefined,
    width: '0',
    height: '0',
    borderTop: '4px solid transparent',
    borderBottom: '4px solid transparent',
    borderLeft: direction === 'ltr' ? '5px solid #77818f' : undefined,
    borderRight: direction === 'rtl' ? '5px solid #77818f' : undefined,
    borderInlineStart: '5px solid #77818f',
    borderRadius: '0'
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RlZmF1bHRTZXBlcmF0b3IudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVlxQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9EZWZhdWx0U2VwZXJhdG9yLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCwgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG50eXBlIFByb3BzID0ge1xuICBjaGlsZHJlbj86IG5ldmVyO1xufVxuXG5jb25zdCBEZWZhdWx0U2VwZXJhdG9yOiBSZWFjdC5GQzxQcm9wcz4gPSAoKSA9PiB7XG4gIGNvbnN0IHsgZGlyZWN0aW9uIH0gPSB1c2VUaGVtZSgpO1xuXG4gIGNvbnN0IHJvb3RTdHlsZXMgPSBjc3Moe1xuICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgIHRvcDogJzUwJScsXG4gICAgdHJhbnNmb3JtOiAndHJhbnNsYXRlWSgtNTAlKScsXG4gICAgekluZGV4OiAxLFxuICAgIGNvbG9yOiAnIzc3ODE4ZicsXG4gICAgY29udGVudDogJ1wiXCInLFxuICAgIHJpZ2h0OiBkaXJlY3Rpb24gPT09ICdsdHInID8gJzVweCcgOiB1bmRlZmluZWQsXG4gICAgbGVmdDogZGlyZWN0aW9uID09PSAncnRsJyA/ICc1cHgnIDogdW5kZWZpbmVkLFxuICAgIHdpZHRoOiAnMCcsXG4gICAgaGVpZ2h0OiAnMCcsXG4gICAgYm9yZGVyVG9wOiAnNHB4IHNvbGlkIHRyYW5zcGFyZW50JyxcbiAgICBib3JkZXJCb3R0b206ICc0cHggc29saWQgdHJhbnNwYXJlbnQnLFxuICAgIGJvcmRlckxlZnQ6IGRpcmVjdGlvbiA9PT0gJ2x0cicgPyAnNXB4IHNvbGlkICM3NzgxOGYnIDogdW5kZWZpbmVkLFxuICAgIGJvcmRlclJpZ2h0OiBkaXJlY3Rpb24gPT09ICdydGwnID8gJzVweCBzb2xpZCAjNzc4MThmJyA6IHVuZGVmaW5lZCxcbiAgICBib3JkZXJJbmxpbmVTdGFydDogJzVweCBzb2xpZCAjNzc4MThmJyxcbiAgICBib3JkZXJSYWRpdXM6ICcwJyxcbiAgfSk7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNzcz17cm9vdFN0eWxlc30gLz5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IERlZmF1bHRTZXBlcmF0b3I7XG4iXX0= */");
  return jsx("div", {
    css: rootStyles
  });
};

export default DefaultSeperator;